import React from 'react';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import Title from './Title';

export default function () {
  return (
    <div className="u-text-center">
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Title className="alpha">
        404
      </Title>
      <p className="gamma u-mb++">The page you requested does not exist.</p>
      <Link to="/">Return to main page.</Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/Route404.jsx